<script lang="js" setup>
import Banner from './Banner.vue'
import HowGetReward from './HowGetReward.vue'
import Overview from './Overview.vue'
import Rules from './Rules.vue'

defineProps({
  overview: {
    type: Object,
    default: () => {},
  },
})

const { t } = useI18n()

const curTab = ref('invite')
const tabs = computed(() => {
  return [
    { title: t('邀请记录'), key: 'invite', component: defineAsyncComponent(() => import('@/components/referral/inviteList')) },
    { title: t('返佣记录'), key: 'rebate', component: defineAsyncComponent(() => import('@/components/referral/rebateList')) },
  ]
})

function tabChange(type) {
  curTab.value = type
}
</script>

<template>
  <div>
    <Banner />
    <div class="w-[1200px] mx-auto">
      <HowGetReward />
      <Overview :overview="overview" />
      <CommonXMod component-class="!px-0 min-h-[400px]" header-class="!px-0 !h-10" :tabs="tabs" :tab="curTab" @tab-change="tabChange" />
      <Rules />
    </div>
  </div>
</template>
